import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import bnblogo from "../avatars/bnbchain.png";
import "./Navbar.css"; // Make sure to update your CSS file

const navLinks = [
  { name: "About", path: "https://www.bnbchain.org/en/blog" },
  { name: "Chains", path: "https://www.bnbchain.org/en/bnb-smart-chain" },
  { name: "Documentation", path: "https://docs.bnbchain.org/" },
];

const dropdownLinks = [
  { name: "Community", path: "https://www.bnbchain.org/en/community" },
  { name: "Ecosystem", path: "https://dappbay.bnbchain.org/" },
  { name: "Github Repo", path: "https://github.com/bnb-chain" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg custom-navbar sticky-top">
      <div className="container-fluid">
        {/* Logo */}
        <a className="navbar-brand d-flex align-items-center" href="#">
          <img src={bnblogo} alt="BNB Chain Logo" className="logo-image" />
        </a>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={isOpen ? "true" : "false"}
          aria-label="Toggle navigation"
          onClick={toggleMobileMenu}
        >
          {isOpen ? <AiOutlineClose className="text-white" /> : <GiHamburgerMenu className="text-white" />}
        </button>

        {/* Desktop and Mobile Links */}
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {navLinks.map((link, index) => (
              <li className="nav-item" key={index}>
                <a className="nav-link" href={link.path}>
                  {link.name}
                </a>
              </li>
            ))}

            {/* Dropdown */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown">
                Community
              </a>
              <ul className="dropdown-menu">
                {dropdownLinks.map((link, index) => (
                  <li key={index}>
                    <a className="dropdown-item" href={link.path}>
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>

          {/* Contact Button */}
          <a className="btn btn-primary contact-btn" href="https://www.bnbchain.org/en/contact" role="button">
            Contact Us
          </a>
        </div>
      </div>
    </nav>
  );
}
